var _style, _path, _path2, _path3, _path4, _circle, _path5, _path6, _rect, _path7, _path8, _path9, _g, _path10, _rect2, _path11, _rect3, _g2, _path12, _path13, _polygon, _g3, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 107",
    style: {
      enableBackground: "new 0 0 104 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F2BB80;}\r\n\t.st1{fill:#4398D1;}\r\n\t.st2{fill:#87CED9;}\r\n\t.st3{fill:#6B402A;}\r\n\t.st4{fill:#126099;}\r\n\t.st5{fill:#D1D1D1;}\r\n\t.st6{fill:#3582BD;}\r\n\t.st7{fill:#539FBD;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,35.5l3.4,11.9h-3.4c0,4.7-3.8,8.5-8.5,8.5l0,0c-4.7,0-8.5-3.8-8.5-8.5V35.5c0-2.8,2.3-5.1,5.1-5.1H23 C25.8,30.4,28.1,32.7,28.1,35.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.2,6.6H36.6c-2.8,0-5.1,2.3-5.1,5.1v10.2c0,2.8,2.3,5.1,5.1,5.1l0,0v5.1l8.5-5.1h22.1c2.8,0,5.1-2.3,5.1-5.1 V11.7C72.3,8.9,70,6.6,67.2,6.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.4,78H74V62.7c0-3.8,3-6.8,6.8-6.8h6.8c3.8,0,6.8,3,6.8,6.8L94.4,78L94.4,78z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.4,78h20.4V62.7c0-3.8-3-6.8-6.8-6.8h-6.8c-3.8,0-6.8,3-6.8,6.8V78z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 21.3,
    cy: 42.3,
    r: 1.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.4,78L9.4,78c0,4.7,3.8,8.5,8.5,8.5h11.9v20.4h11.9l-3.4-5.1v-17c0-3.8-3-6.8-6.8-6.8L9.4,78L9.4,78z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23.5,103.6l-9-3v-7.3h-3.4v7.3l-9,3c-0.9,0.3-1.4,1.3-1.1,2.2c0.3,0.9,1.3,1.4,2.2,1.1l9.7-3.3l9.7,3.3 c0.2,0,0.4,0,0.5,0c0.7,0,1.4-0.5,1.6-1.2C24.9,104.9,24.4,103.9,23.5,103.6C23.5,103.6,23.5,103.6,23.5,103.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.9,
    y: 55.9,
    className: "st4",
    width: 3.4,
    height: 17
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23,37.2h-6.8L11.1,44v-8.5c0-2.8,2.3-5.1,5.1-5.1h13.6C29.8,34.2,26.7,37.2,23,37.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.7,35.5l-3.4,11.9h3.4c0,4.7,3.8,8.5,8.5,8.5l0,0c4.7,0,8.5-3.8,8.5-8.5V35.5L75.7,35.5L75.7,35.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.7,35.5L92.7,35.5c0-2.8-2.3-5.1-5.1-5.1H74.8c-1.4,0-2.6,1.1-2.6,2.6c0,1.4,1.1,2.6,2.6,2.6h11.1l6.8,8.5 L92.7,35.5L92.7,35.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.6,
    y: 11.7,
    className: "st6",
    width: 30.6,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.6,
    y: 18.5,
    className: "st6",
    width: 6.8,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.8,
    y: 18.5,
    className: "st6",
    width: 20.4,
    height: 3.4
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.1,27c2.8,0,5.1,2.3,5.1,5.1v3.4c0,2.8-2.3,5.1-5.1,5.1h-3.4v5.1l-8.5-5.1h-5.1c-2.8,0-5.1-2.3-5.1-5.1v-3.4 c0-2.8,2.3-5.1,5.1-5.1C45.1,27,62.1,27,62.1,27z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8,
    y: 69.5,
    className: "st3",
    width: 44.2,
    height: 5.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.7,103.6l-9-3v-7.3h-3.4v7.3l-9,3c-0.9,0.3-1.4,1.3-1.1,2.2c0.3,0.9,1.3,1.4,2.2,1.1l9.7-3.2l9.7,3.3 c0.2,0,0.4,0,0.5,0c0.8,0,1.5-0.4,1.7-1.2C103.2,104.9,102.7,103.9,101.7,103.6C101.8,103.6,101.8,103.6,101.7,103.6z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 55.9,
    className: "st1",
    width: 3.4,
    height: 17
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.4,86.5h10.2c1.9,0,3.4,1.5,3.4,3.4l0,0c0,1.9-1.5,3.4-3.4,3.4H7.7c-2.8,0-5.1-2.3-5.1-5.1V64.4 C2.6,62.5,4.1,61,6,61l0,0c1.9,0,3.4,1.5,3.4,3.4V86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.4,86.5H84.2c-1.9,0-3.4,1.5-3.4,3.4l0,0c0,1.9,1.5,3.4,3.4,3.4h11.9c2.8,0,5.1-2.3,5.1-5.1V64.4 c0-1.9-1.5-3.4-3.4-3.4l0,0c-1.9,0-3.4,1.5-3.4,3.4L94.4,86.5L94.4,86.5z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45.1,69.5H29.8v-3.4h14.1l4.7-12.5l3.2,1.2l-5.1,13.6C46.4,69.1,45.8,69.5,45.1,69.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.4,78L94.4,78c0,4.7-3.8,8.5-8.5,8.5H74v20.4H62.1l3.4-5.1v-17c0-3.8,3-6.8,6.8-6.8L94.4,78L94.4,78z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "53.6,103.5 53.6,74.6 50.2,74.6 50.2,103.5 41.7,103.5 41.7,106.9 62.1,106.9 62.1,103.5 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.1,
    y: 32.1,
    className: "st7",
    width: 10.2,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.7,
    y: 32.1,
    className: "st7",
    width: 3.4,
    height: 3.4
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 80.8,
    cy: 42.3,
    r: 1.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.a88735dcba4e60b59917a546533f0174.svg";
export { ForwardRef as ReactComponent };